export class Animator {
    elem;
    elemAnimation = undefined;
    handler = undefined;
    constructor(elem) {
        this.elem = elem;
    }
    cancel() {
        if (this.elemAnimation) {
            // Cancel the current animation
            this.elemAnimation.cancel();
            this.elemAnimation = undefined;
            if (this.handler)
                this.handler(this.elem, false);
            this.handler = undefined;
        }
    }
    animate(keyframes, options, handler) {
        this.cancel();
        this.handler = handler;
        this.elemAnimation = this.elem.animate(keyframes, options);
        this.elemAnimation.onfinish = () => {
            this.elemAnimation = undefined;
            if (this.handler) {
                this.handler(this.elem, true);
                this.handler = undefined;
            }
        };
    }
}
